module.exports = __webpack_public_path__ + "static/img/emt_example_payment3.cddde9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emt_example_payment3.jpg
// module id = gyel
// module chunks = 0